import { createWebHistory, createRouter } from "vue-router";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import UserProfile from "@/views/UserProfile.vue";
import SearchGrants from "@/views/SearchGrants.vue";
import News from "@/views/News.vue";
import GrantDetails from "@/views/GrantDetails.vue";
import Unauthorized from "@/views/Unauthorized.vue";
import NewsDetails from "@/views/NewsDetails";
import ResetPassword from "@/views/ResetPassword.vue";
import NewPassword from "@/views/NewPassword.vue";
import HomePage from "@/views/HomePage.vue";
import UploadDocument from "@/views/UploadDocument.vue";
import FilesOverview from "@/views/FilesOverview.vue";
import FileRecordsOverview from "@/views/FileRecordsOverview.vue";
import DeadlinesSchemes from "../components/homepage-components/DeadlinesSchemes.vue";
import NewestSchemes from "../components/homepage-components/NewestSchemes.vue";
import LatestNews from "../components/homepage-components/LatestNews.vue";
import SignificantChanges from "../components/homepage-components/SignificantChanges";
import StatisticsOverview from "@/views/Statistics/StatisticsOverview.vue";
import store from "../store/index";
import authService from "../services/auth.service";

const routes = [
  {
    path: "/",
    component: Login,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/change-password/token=:token(.*)",
    name: "NewPassword",
    component: NewPassword,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile/:tab",
    name: "UserProfile",
    component: UserProfile,
  },
  {
    path: "/search-grants",
    name: "SearchGrants",
    component: SearchGrants,
  },
  {
    path: "/news",
    name: "News",
    component: News,
  },
  {
    path: "/grant/:grantId/details:term?",
    name: "GrantDetails",
    component: GrantDetails,
  },
  {
    path: "/news/view/:newsId",
    name: "NewsDetails",
    component: NewsDetails,
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
  },
  {
    path: "/upload-document",
    name: "UploadDocument",
    component: UploadDocument,
  },
  {
    path: "/files-overview",
    name: "FilesOverview",
    component: FilesOverview,
  },
  {
    path: "/file-records-overview/:fileId",
    name: "FileRecordsOverview",
    component: FileRecordsOverview,
  },
  {
    path: "/home-page",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/home-page/deadlines",
    name: "DeadlinesSchemes",
    component: DeadlinesSchemes,
  },
  {
    path: "/home-page/newest",
    name: "NewestSchemes",
    component: NewestSchemes,
  },
  {
    path: "/home-page/latest-news",
    name: "LatestNews",
    component: LatestNews,
  },
  {
    path: "/home-page/significant-changes",
    name: "SignificantChanges",
    component: SignificantChanges,
  },
  {
    path: "/statistieken",
    name: "StatisticsOverview",
    component: StatisticsOverview,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const publicPages = [
    "/login",
    "/register",
    "/reset-password",
    "/new-password",
    "/change-password",
  ];

  const authUserId = store.state.auth.authUser.id;

  const routeContainsElementFromPublicPages = publicPages.some((element) => {
    if (to.path.includes(element)) {
      return true;
    }
    return false;
  });

	if (routeContainsElementFromPublicPages) {
		return next();
	}

	if (authUserId) {
		return next();
	}
	
	if (to.path.substring(0, 10) === "/news/view") {
    store.commit("user/setHasComeFromNewsletter", true);
    store.commit("user/setNewsletterParams", to.params);
  }
	
  try {
    await authService.getAuthUserData();
    next();
  } catch (err) {
    next({
      name: 'Login',
      query: { returnUrl: to.fullPath },
    });
  }
});

export default router;
